module.exports = __webpack_public_path__ + "static/img/a1.fe5b97d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/article/androidMessageSet/a1.png
// module id = Q7ml
// module chunks = 0